import {ValueObject} from '@s-ui/domain'

export class MetadataRecommendedAdsValueObject extends ValueObject {
  /**
   * @param {String} itemId
   * @param {String} listName
   * @param {String} recommendationId
   * @param {Boolean} isEmpty
   */

  constructor({itemId, listName, recommendationId, isEmpty}) {
    super({itemId, listName, recommendationId, isEmpty})

    /**
     * @type {String}
     */
    this._itemId = itemId

    /**
     * @type {String}
     */
    this._listName = listName

    /**
     * @type {String}
     */
    this._recommendationId = recommendationId

    /**
     * @type {Boolean}
     */
    this._isEmpty = isEmpty
  }

  getItemId() {
    return this._itemId
  }

  getListName() {
    return this._listName
  }

  getRecommendationId() {
    return this._recommendationId
  }

  getIsEmpty() {
    return this._isEmpty
  }

  toJSON() {
    return {
      itemId: this.getItemId(),
      listName: this.getListName(),
      recommendationId: this.getRecommendationId(),
      isEmpty: this.getIsEmpty()
    }
  }
}
